var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { hasData: true, loading: _vm.loading } },
    [
      _c("InformationWrapper", {
        scopedSlots: _vm._u(
          [
            {
              key: "primary",
              fn: function () {
                return [
                  _c(
                    "InformationCard",
                    { staticClass: "px-2", attrs: { title: "Background" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "CardBodyItem",
                            {
                              staticClass: "mb-1 w-full",
                              attrs: {
                                label: "Tags",
                                wide: "",
                                totalNumber: _vm.skills2?.length,
                              },
                            },
                            [
                              _vm.skills2?.length > 0
                                ? _c("ChipsWithMore", {
                                    attrs: { chipWithLinkDatas: _vm.skills2 },
                                  })
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "font-normal text-base text-gray-new",
                                    },
                                    [_vm._v(" No tags added. ")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col w-full relative justify-between items-start mb-10",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row justify-between items-start w-full",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                },
                                [
                                  _vm._v(" Rate "),
                                  _c(
                                    "span",
                                    { staticClass: "totalNumber ml-0.5" },
                                    [_vm._v(_vm._s(_vm.getRateLength))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          !!_vm.contractorRates.length
                            ? _c(
                                "div",
                                _vm._l(_vm.contractorRates, function (item) {
                                  return _c(
                                    "span",
                                    {
                                      key: item.name,
                                      staticClass:
                                        "text-badgeBlue text-base font-normal customLineH",
                                    },
                                    [_vm._v("$" + _vm._s(item.name) + " ")]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm.contractorRates.length === 0
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new",
                                },
                                [_vm._v(" No rate added. ")]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "CardBodyItem",
                            {
                              staticClass: "mb-1",
                              attrs: {
                                label: "Industries",
                                wide: "",
                                totalNumber: _vm.industries2?.length,
                              },
                            },
                            [
                              _vm.industries2.length > 0
                                ? _c("ChipsWithMore", {
                                    attrs: {
                                      chipWithLinkDatas: _vm.industries2,
                                    },
                                  })
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "font-normal text-base text-gray-new",
                                    },
                                    [_vm._v(" No industries added. ")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "CardBodyItem",
                            {
                              staticClass: "mb-1",
                              attrs: {
                                label: "Languages",
                                wide: "",
                                totalNumber: _vm.languages2?.length,
                              },
                            },
                            [
                              _vm.languages2.length > 0
                                ? _c("ChipsWithMore", {
                                    attrs: {
                                      chipWithLinkDatas: _vm.languages2,
                                    },
                                  })
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "font-normal text-base text-gray-new",
                                    },
                                    [_vm._v(" No languages added. ")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col justify-between items-start w-full mb-10",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row w-full relative justify-between items-start",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                },
                                [
                                  _vm._v("Previous Work"),
                                  _c(
                                    "span",
                                    { staticClass: "totalNumber ml-0.5" },
                                    [_vm._v(_vm._s(_vm.getWorkCount))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm.workSamples !== null
                            ? _c("Slider", {
                                attrs: { items: _vm.workSamples },
                              })
                            : _vm._e(),
                          _vm.workSamples === null
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new",
                                },
                                [_vm._v(" No previous work added. ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col w-full justify-between items-start",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row justify-between items-start w-full",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                },
                                [
                                  _vm._v(" Experience "),
                                  _vm.experiences?.length > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "totalNumber ml-0.5" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(_vm.experiences?.length) +
                                              ")"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm.experiences?.length > 0
                            ? _c(
                                "div",
                                { staticClass: "w-full mb-10" },
                                _vm._l(_vm.experiences, function (experience) {
                                  return _c("ExperienceCard", {
                                    key: experience.id,
                                    staticClass: "card",
                                    attrs: {
                                      jobTitle: experience.job_title,
                                      companyName: experience.company_name,
                                      industry: experience.industry,
                                      skills: experience.skills,
                                      summary: experience.summary,
                                      isAddedBy: experience.added_by_id,
                                      employmentType:
                                        experience.employment_type,
                                      location: experience.location,
                                      startDate: experience.start_date,
                                      endDate: experience.end_date,
                                    },
                                  })
                                }),
                                1
                              )
                            : _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new mb-10",
                                },
                                [_vm._v(" No experience added. ")]
                              ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col w-full relative justify-between items-start",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row justify-between items-start w-full",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                },
                                [
                                  _vm._v(" Education "),
                                  _vm.educations?.length > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "totalNumber ml-0.5" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(_vm.educations?.length) +
                                              ")"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm.educations?.length > 0
                            ? _c(
                                "div",
                                { staticClass: "w-full" },
                                _vm._l(_vm.educations, function (education) {
                                  return _c("EducationCard", {
                                    key: education.id,
                                    staticClass: "card mb-10",
                                    attrs: {
                                      title: education.title,
                                      institution: education.institution,
                                      summary: education.summary,
                                      startDate: education.start_date,
                                      isAddedBy: education.added_by_id,
                                      endDate: education.end_date,
                                    },
                                  })
                                }),
                                1
                              )
                            : _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new",
                                },
                                [_vm._v(" No education added. ")]
                              ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col w-full relative justify-between items-start mt-10",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row justify-between items-start w-full",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                },
                                [
                                  _vm._v(" Certification "),
                                  _vm.certifications.length > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "totalNumber ml-0.5" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.certifications?.length
                                              ) +
                                              ")"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm.certifications?.length > 0
                            ? _c(
                                "div",
                                { staticClass: "w-full" },
                                _vm._l(
                                  _vm.certifications,
                                  function (certification) {
                                    return _c("CertificationCard", {
                                      key: certification.id,
                                      staticClass: "card mb-10",
                                      attrs: {
                                        title: certification.title,
                                        institution: certification.institution,
                                        startDate: certification.start_date,
                                        isAddedBy: certification.added_by_id,
                                        endDate: certification.end_date,
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-base text-gray-new",
                                },
                                [_vm._v(" No certifications added. ")]
                              ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "InformationEmptyAboutCard",
                    [
                      _vm.resourceCard.length < 1
                        ? _c("div", { staticClass: "w-full" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "flex font-400 labelWidth text-left leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                              },
                              [
                                _vm._v(" Resource Information "),
                                _vm.resourceCard.length > 0
                                  ? _c(
                                      "span",
                                      { staticClass: "totalNumber ml-0.5" },
                                      [
                                        _vm._v(
                                          "(" +
                                            _vm._s(_vm.resourceCard?.length) +
                                            ")"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "w-full flex justify-center" },
                              [
                                _c("EmptyResourceInformationPlaceholder", {
                                  attrs: {
                                    description:
                                      "This information will be available once you have access to this Resource",
                                    desc: "",
                                    contractorId: _vm.contractorId,
                                    currentUserId: _vm.currentUserId,
                                    isAccessGranted: _vm.isAccessGranted,
                                  },
                                  on: {
                                    open: _vm.showModal,
                                    refresh: _vm.refreshPage,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "image",
                                        fn: function () {
                                          return [_c("EmptyListImageDocuments")]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2273432899
                                  ),
                                }),
                              ],
                              1
                            ),
                          ])
                        : _c("ResourceDataTable", {
                            attrs: {
                              currentUserId: _vm.currentUserId,
                              resourceCard: _vm.resourceCard,
                              contractorId: _vm.contractorId,
                              title: "Resource Information",
                              total: _vm.resourceCard?.length,
                            },
                            on: {
                              open: _vm.showModal,
                              refresh: _vm.refreshPage,
                            },
                          }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "secondary",
              fn: function () {
                return [
                  _c(
                    "div",
                    [
                      _vm._t("startSecondaryList", null, {
                        secondaryItemClasses: _vm.secondaryItemClasses,
                      }),
                      _c(
                        "CardBodyItem",
                        {
                          staticClass: "border-b-1",
                          class: _vm.secondaryItemClasses,
                          attrs: { label: "Website" },
                        },
                        [
                          _c("NewTabLink", {
                            staticClass: "truncate",
                            attrs: { url: _vm.profile.website },
                          }),
                        ],
                        1
                      ),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "Company",
                          content: _vm.profile.company_name,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "Job Title",
                          content: _vm.profile.job_title,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "Rate",
                          content: _vm.contractorRates,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "Country",
                          content: _vm.profile.country,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: _vm.stateProvinceLabel,
                          content: _vm.profile.state,
                          highlightContent: "",
                        },
                      }),
                      _c("CardBodyItem", {
                        staticClass: "border-b-1",
                        class: _vm.secondaryItemClasses,
                        attrs: {
                          label: "City",
                          content: _vm.profile.city,
                          highlightContent: "",
                        },
                      }),
                      _vm._t("endSecondaryList", null, {
                        secondaryItemClasses: _vm.secondaryItemClasses,
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    [
                      _c("DownloadResume", {
                        attrs: { resumeName: _vm.profile.resume },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }